import {
  membershipTransactionStatusMeta,
  MembershipTransactionStatus,
} from '@models/membership/MembershipTransaction'
import { Tag } from 'antd'

interface Props {
  status: MembershipTransactionStatus
}

/**
 * Single renderer for a transaction's lifecycle status, shared by the tables
 * and the "View" drawer.
 *
 * The status is NOT a stored column: the API derives it from
 * `completed_at`/`failed_at` (`SubscriptionPayment::status()`, precedence
 * completed > failed > pending) and sends the token, so nothing is computed
 * here - `membershipTransactionStatusMeta` only maps that token to its AntD
 * colour and label.
 */
const TransactionStatusTag = ({ status }: Props) => {
  const meta = membershipTransactionStatusMeta[status]

  return <Tag color={meta.badge}>{meta.label}</Tag>
}

export { TransactionStatusTag }
